export const UPDATE_WEIGHT_REAL = {
    REQUEST: 'BAGS.UPDATE_WEIGHT_REAL.REQUEST',
    SUCCESS: 'BAGS.UPDATE_WEIGHT_REAL.SUCCESS',
    FAILED: 'BAGS.UPDATE_WEIGHT_REAL.FAILED',
};

export const RESET_ERROR_UPDATE_WEIGHT_REAL_BAG = "RESET_ERROR_UPDATE_WEIGHT_REAL_BAG";
